import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const GET_WEBHOOK_MAX_ALLOWED_PROPERTIES = registerQuery({
  fieldName: 'webhookMaxAllowedProperties',
  args: [],
  fetcher: () => {
    return http.get('portal-event-ingest/v1/webhook-definitions/limits');
  }
});
export const GET_WEBHOOK_DEFINITIONS = registerQuery({
  fieldName: 'webhookDefinitions',
  args: ['objectTypeId'],
  fetcher: ({
    objectTypeId
  }) => {
    return http.get('portal-event-ingest/v1/webhook-definitions', {
      query: {
        objectTypeId
      }
    });
  }
});
export const INITIALIZE_WEBHOOK = registerQuery({
  fieldName: 'initializeWebhook',
  fetcher: () => http.post(`portal-event-ingest/v1/webhook-initializer`)
});
export const GET_WEBHOOK_DATA = registerQuery({
  fieldName: 'webhookData',
  args: ['callbackId'],
  fetcher: ({
    callbackId
  }) => {
    return http.get(`portal-event-ingest/v1/webhook-initializer/${callbackId}`);
  }
});
export const INGEST_WEBHOOK_DEF = registerQuery({
  fieldName: 'ingestWebhookDef',
  args: ['webhookIngestionBody'],
  fetcher: ({
    webhookIngestionBody
  }) => {
    return http.post('portal-event-ingest/v1/webhook-definitions', {
      data: webhookIngestionBody
    });
  }
});
export const UPDATE_WEBHOOK_DEFINITION = registerQuery({
  fieldName: 'updateWebhookDef',
  args: ['webhookDefinition'],
  fetcher: ({
    webhookDefinition
  }) => {
    return http.patch(`portal-event-ingest/v1/webhook-definitions/${webhookDefinition.definitionId}`, {
      data: webhookDefinition
    });
  }
});
export const BATCH_RESPONSE_WEBHOOK_INGEST_DEFINITION = registerQuery({
  fieldName: 'batchResponseWebhookIngestDefinition',
  args: ['eventTypeIds'],
  fetcher: ({
    eventTypeIds
  }) => http.post('portal-event-ingest/v1/webhook-definitions/event-type-ids/batch/read', {
    data: {
      inputs: eventTypeIds
    }
  })
});
export const DELETE_WEBHOOK_DEFINITION = registerQuery({
  fieldName: 'deleteWebhookDefinition',
  args: ['definitionId'],
  fetcher: ({
    definitionId
  }) => http.delete(`portal-event-ingest/v1/webhook-definitions/${definitionId}`, {
    query: {
      purge: true
    }
  })
});